import { render, staticRenderFns } from "./OperatorDocumentsData.vue?vue&type=template&id=356825c5&"
import script from "./OperatorDocumentsData.vue?vue&type=script&lang=ts&"
export * from "./OperatorDocumentsData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports